/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PawnIcon = ({ width = 24, height = 24, hidden = false, title = 'Pawn' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx=".894" ry=".894" width="24" x="6" y="32" />
    <path
      d="M25.184 12H21.31a6 6 0 1 0-6.619 0h-3.875a.816.816 0 0 0-.816.816v2.367a.816.816 0 0 0 .816.816H15L12 30h12l-3-14h4.184a.816.816 0 0 0 .816-.816v-2.368a.816.816 0 0 0-.816-.816Z"
    />
  </svg>`;
};
